import RouteWrapper from "@/components/common/RouteWrapper.vue";
import sidebarData from "@/data/sidebar";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import Roles from "@/entities/Roles";
import RouteNames from "@/entities/RouteNames";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";

const Timesheet = () =>
  import("@/views/timesheet/List.vue").then((m) => m.default);
const admin = sidebarData.find(
  (a) =>
    (a.role.includes(Roles.ADMIN) || a.role.includes(Roles.MANAGER)) &&
    a.slug === "/manage"
);
const contractor = sidebarData.find((a) => a.role.includes(Roles.CONTRACTOR));
const ContractorTimesheet = () =>
  import("@/views/timesheet/ContractorTimesheets.vue").then((m) => m.default);

const getTimesheetRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/timesheet",
    component: RouteWrapper,
    meta: {
      title: "Timesheet",
      requiresAuth: true,
      breadcrumb: {
        title: (user) =>
          user?.role === Roles.CONTRACTOR
            ? (contractor.title as string)
            : (admin.title as string),
        routeName: (user) =>
          user?.role === Roles.CONTRACTOR
            ? RouteNames.CONTRACTOR_TIMESHEETS
            : RouteNames.TIMESHEET,
        isStyled: true,
      },
    },
  },
]);

const getTimesheetPrivatePageTabsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "manage",
    name: RouteNames.TIMESHEET,
    component: Timesheet,
    meta: {
      title: "Timesheet",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: "Timesheets",
        routeName: RouteNames.TIMESHEET,
        isStyled: true,
      },
    },
  },
  {
    path: "/",
    name: RouteNames.CONTRACTOR_TIMESHEETS,
    component: ContractorTimesheet,
    meta: {
      title: "Timesheet",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        title: "Timesheets",
        routeName: RouteNames.CONTRACTOR_TIMESHEETS,
        isStyled: true,
      },
    },
  },
]);
const getTimesheetPrivateSubmit: GetRelativeRoutes = getChildRoutes([]);

export {
  getTimesheetPrivatePageTabsRoutes,
  getTimesheetPrivateSubmit,
  getTimesheetRoutes,
};
